import Vue, {PluginObject} from 'vue';
import axios from 'axios';
import {loadToken} from "@/modules/unigest";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    (config) => {
        config.headers['Application-Type'] = 'unigest.web'
        // La aplicación se encuentra en desarrollo se utilizara la URL de Unigest en
        // el archivo de entorno
        if (process.env.NODE_ENV === 'development') {
            config.baseURL = process.env.VUE_APP_UNIGEST_SERVER || ''
        }

        const token = loadToken()
        if (token) {
            config.headers['Authorization'] = `Bearer ${token.token}`
            // Si el entorno se encuentra en producción utilizará la api provista por el
            // enrutador
            if (process.env.NODE_ENV === 'production') {
                config.baseURL = token.context.api_url
            }
        }

        return config
    },
    (err) => {
        // Do something with request error
        return Promise.reject(err);
    },
);

// Add a response interceptor
_axios.interceptors.response.use(
    (res) => {
        // Do something with response data
        return res;
    },
    (err) => {
        // Do something with response error
        return Promise.reject(err);
    },
);

const Plugin: PluginObject<any> = {
    install: (Vue) => {
        Vue.$axios = _axios;
    },
};
Plugin.install = (Vue) => {
    Vue.$axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        $axios: {
            get() {
                return _axios;
            },
        },
    });
};

Vue.use(Plugin);

export default Plugin;
export {_axios as client}
